export default "__VITE_ASSET__CjGEN08g__"